<template>

    <AjanlatBase :titleExtra="titleExtra"
                 v-if="lakasVisible()
                 || eletVisible()
                 || cascoVisible()
                 || tobbjarmuVisible()
                 || munkahelyVisible()
                 || szerzAzonVisible()
                 || greenCardVisible()">

        <v-form slot="biztositoi-adatok" ref="ajanlat-adatok">

            <v-layout row wrap>

                <template v-if="lakasVisible()">

                    <BnFormField
                        :key="`groupama_szerz_azon2_${index}`"
                        v-for="(x, index) in getLakasDb()"
                        :attributes="{
                        type: 'text',
                        label: 'Lakásbiztosítás szerződés azonosító',
                        visible: true,
                        editable: true,
                        help: false,
                        path: 'tarifaData.groupama.tf_8_groupama_szerz_azon2_' + (x - 1),
                        mezo: 'groupama_szerz_azon2'
                    }"/>

                </template>

                <template v-if="eletVisible()">

                    <BnFormField
                        :key="`groupama_szerz_azon4_${index}`"
                        v-for="(x, index) in getEletDb()"
                        :attributes="{
                        type: 'text',
                        label: 'Életbiztosítás szerződés azonosító',
                        visible: true,
                        editable: true,
                        help: false,
                        path: 'tarifaData.groupama.tf_8_groupama_szerz_azon4_' + (x - 1),
                        mezo: 'groupama_szerz_azon4'
                    }"/>

                </template>

                <template v-if="cascoVisible()">

                    <BnFormField :key="`tf_8_groupama_szerz_azon3_${index}`" v-for="(x, index) in getCascoDb()"
                                 :attributes="{
                        type: 'text',
                        label: 'Cascobiztosítás szerződés azonosító',
                        visible: true,
                        editable: true,
                        help: false,
                        path: 'tarifaData.groupama.tf_8_groupama_szerz_azon3_' + (x - 1),
                        mezo: 'tf_8_groupama_szerz_azon3_' + (x - 1)
                    }"/>
                </template>

                <template v-if="tobbjarmuVisible()">

                    <BnFormField :key="`groupama_szerz_azon5_${index}`" v-for="(x, index) in getTobbautoDb()"
                                 :attributes="{
                        type: 'text',
                        label: 'Másik gépjármű szerződésszáma vagy ajánlatszáma',
                        visible: true,
                        editable: true,
                        help: false,
                        path: 'tarifaData.groupama.tf_8_groupama_szerz_azon5_' + (x - 1),
                        mezo: 'groupama_szerz_azon5'
                    }"/>

                </template>

                <BnFormField v-if="munkahelyVisible()" :attributes="{
                    type: 'select',
                    label: 'Munkahely',
                    visible: true,
                    editable: true,
                    help: true,
                    path: 'tarifaData.kgfb_group_munkahely',
                    mezo: 'kgfb_group_munkahely',
                    resource: listTypes.groupama_munkahely,
                    itemsText: 'value',
                    itemsValue: 'key',
                }"/>

                <BnFormField v-if="szerzAzonVisible()" :attributes="{
                    type: 'text',
                    label: 'Preventor vagyon és felelősségbiztosítás szerződésszáma',
                    visible: true,
                    editable: true,
                    help: true,
                    mezo: 'tf_8_groupama_szerz_azon6',
                    path: 'tarifaData.groupama.tf_8_groupama_szerz_azon6',
                }"/>

              <BnFormField v-if="greenCardVisible()" :attributes="{
                    type: 'select',
                    label: 'Rendszeres Zöldkártya igénylés',
                    visible: true,
                    editable: true,
                    help: true,
                    path: 'tarifaData.groupama_zoldkartya_igenyles',
                    mezo: 'groupama_zoldkartya_igenyles',
                    resource: listTypes.groupama_zoldkartya_igenyles,
                    default: listTypes.groupama_zoldkartya_igenyles[0],
                    itemsText: 'value',
                    itemsValue: 'key',
                }"/>

            </v-layout>

        </v-form>

    </AjanlatBase>

</template>

<script>
import { listTypes } from '../../../../../../../../modules/List';
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import AjanlatBase from '../KGFBAjanlatBase.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';
import TariffAnnouncementUtils from '../../../../../../../../utils/TariffAnnouncementUtils';

export default {
    components: { BnFormField, AjanlatBase },
    mixins: [offerData],
    methods: {
        getLakasDb() {
            return this.kedvezmenyek.lakbizt;
        },
        getEletDb() {
            return this.kedvezmenyek.eletbizt;
        },
        getCascoDb() {
            let db = this.kedvezmenyek.casco;
            if (db === 0
                && [18, 118].includes(parseInt(this.$store.getters.tarifaData.szerz_casco, 10))) db = 0;
            return db;
        },
        getTobbautoDb() {
            return this.kedvezmenyek.csaladitobbjarmu;
        },
        lakasVisible() {
            return this.getLakasDb() > 0;
        },
        eletVisible() {
            return this.getEletDb() > 0;
        },
        cascoVisible() {
            return this.getCascoDb() > 0;
        },
        tobbjarmuVisible() {
            return this.getTobbautoDb() > 0;
        },
        munkahelyVisible() {
            return this.kedvezmenyek.otpdolg === true;
        },
        szerzAzonVisible() {
            return this.kedvezmenyek.preventor === true;
        },
        greenCardVisible() {
            return TariffAnnouncementUtils.isKockakezdetEqualOrGreater(2023, 'kgfb', this.$store)
                && this.$store.getters.tarifaData.eugyintezes;
        },
    },
    data() {
        return {
            listTypes,
            name: 'AjanlatAdatokB8_V0',
            version: 'v0',
        };
    },
};
</script>
